import { Box, Button, Typography } from '@mui/material';
import Tile from 'features/layout/tiles/Tile';
import { styled } from '@mui/material/styles';
import cx from 'clsx';

const Root = styled(Box)(({ theme }) => ({
  padding: `${theme.room.tileGap}px`,
  width: '100%',
  height: '100%',
  '&.floating': {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1100,
  },
}));

type PipActionTileProps = {
  message: string;
  actionLabel: string;
  onAction: () => void;
  floating?: boolean;
};

export const PipActionTile = ({ message, actionLabel, onAction, floating }: PipActionTileProps) => (
  <Root className={cx({ floating })}>
    <Tile cols={1} sx={{ height: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
        <Typography
          variant="body2"
          sx={(theme) => ({
            mb: 4,
            textAlign: 'center',
            color: theme.palette.getContrastText(theme.room.tileBackground),
          })}
        >
          {message}
        </Typography>

        <Button size="medium" type="button" variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      </Box>
    </Tile>
  </Root>
);
